import React from "react";

function TextFieldWithIcon(props) {
  const onChangeHandler = (event) => {
    props.onChange(event.target.value);
  };

  return (
    <div
      className={`ui icon left labeled input input-container ${props.className}`}
    >
      <input
        type="text"
        placeholder={props.placeholder}
        value={props.value}
        onChange={onChangeHandler}
      />
      {props.icon}
    </div>
  );
}

export default TextFieldWithIcon;
